import validateUrl from './validateUrl';

const validateFormAlias = (alias, domain) => {
  const error = Boolean(domain?.enabled && !validateUrl(`a.com/${alias?.value}`));
  return error ? 'This is not a valid alias' : false;
};

export default validateFormAlias;
